export enum BillChargesEnum {
  BILLING_GROUP = "billing_group",
  CHARGE_CODE = "charge_codes",
}
